import moment from "moment";
import { getLocalFormattedDate } from "../../utils/getLocalFormattedDate";
import { Avatar, Flex } from "antd";
import { UserOutlined } from "@ant-design/icons";

const WorkflowHistory = (props) => {
    const { requestDetail } = props;
    const history = requestDetail?.activityLogs || []

    return (
        <div className="workflow-history">
            {
                history.map((data, index) => {
                    return (
                        <div key={"history-" + index} className="history-row">
                            <Flex gap={8}>
                                <div className="profile-img">
                                    <Avatar size={32} icon={<UserOutlined />} />
                                </div>
                                <div className="history-info">
                                    <div className="history-title">{data?.message}</div>
                                    <div className="history-date ">{getLocalFormattedDate(data.updatedOn)}</div>
                                </div>
                            </Flex> 
                        </div>

                    )
                })
            }
        </div>
    )
}

export default WorkflowHistory